import { IEnvironment } from "./model.environment";
import { prod } from './data.environment';


export class Environment extends IEnvironment {
  static override readonly appTitle: string = 'AmWager';
  static override readonly production: boolean = true;
  static override readonly domain: string = 'amwager.com';
  static override readonly urlAPI: string = 'https://wagerapi.amwager.com/';
  static override readonly urlAPIStable: string = 'https://aws-stable-api.azurewebsites.net/';
  static override readonly locale = 'en-US' as const;
  static override readonly currencyCode = 'USD' as const;
  static override readonly defaultRoleId: number = 10;
  static override readonly ui: string = 'Web-pro';
  static override readonly orgId: string = prod?.orgId;
  static override readonly gtmId: string = prod?.gtmId;
  static override readonly enableAnalytics: boolean = true;
  static override readonly enableDevToolsRedux: boolean = false;
  static override readonly enableComponentView: boolean = false;
  static override readonly homeDirectory: string = 'wager';
  static override readonly stableAPIKey: string = prod?.stableAPIKey;
  static override readonly pusher = {
    key: prod?.pusher?.key,
    cluster: 'us2',
    beams: {
      instanceId: prod?.pusher?.beams?.instanceId,
      secretKey: prod?.pusher?.beams?.secretKey
    }
  };
  static override readonly eProtect = {
    url: 'https://request.eprotect.vantivcnp.com/eProtect/js/eProtect-iframe-client3.min.js',
    jQuery: 'https://ajax.googleapis.com/ajax/libs/jquery/1.4.2/jquery.min.js',
    css: 'amwagerWPv5a',
    reportGroup: 'AmWagerPro'
  };
  static override readonly environment: string = 'production';
  static override readonly debug: boolean = false;
  static override readonly smartlook: string = prod?.smartlook;
}
